import { useEMTState } from '@/store'
import { RegistrationType } from '@/dataV3/User/ConnectedUser'
import { Picture } from '@/dataV3/Common/Picture'

const useCurrentUser = () => {
  const { currentUser, currentPendingUser, currentPetsitter } = useEMTState().user

  const currentUnknownUser = currentUser || currentPendingUser || currentPetsitter

  // Check if this is an array, because of a backend bug, that might return an object instead of an array
  const allPictures: Picture[] | undefined = Array.isArray(currentUser?.pictures)
    ? currentUser?.pictures
    : Array.isArray(currentPendingUser?.pictures)
    ? currentPendingUser?.pictures
    : []
  const avatar = allPictures?.find((picture) => picture && picture.isMain)

  const pictures = allPictures?.filter((picture) => picture && !picture.isMain)
  const allPicturesUrls = [avatar?.url ?? '', ...(pictures?.map((picture) => picture?.url) ?? [])]

  return {
    currentUser: currentUser
      ? {
          ...currentUser,
          animals: Array.isArray(currentUser.animals) ? currentUser.animals.filter((animal) => !animal.fakeAnimal) : [],
        }
      : currentUser,
    currentPendingUser,
    currentPetsitter,
    currentUnknownUser,
    isPremium: !!currentUser?.isPremium,
    isCertified: !!currentUser?.settings?.certificationStatus?.isCertified,
    isPetsitterInRegistration: currentUnknownUser?.registrationType === RegistrationType.petsitterInRegistration,
    isPetSitter: currentUser?.registrationType === RegistrationType.petsitter,
    isOwner: currentUser?.registrationType === RegistrationType.petowner,
    isBorrower: currentUser?.registrationType === RegistrationType.borrower,
    avatar: avatar as Picture | undefined, // Force type because TS infer no undefined
    pictures,
    allPictures,
    allPicturesUrls,
    settings: currentUser?.settings,
    tendersEnabled: !!currentUser?.tendersEnabled,
    hasRequestedPetsitting: !!currentUser?.hasRequestedPetsitting,
  }
}

export default useCurrentUser
